const state = {
  rolesData: null,
  needcache: false,
  isValid: 2,
  currentRow: null,
  optionsGrade: [], // 年级数据（修改角色）
  gradeValue: ''
}
const mutations = {
  changeRolesData: (state, obj) => {
    state.rolesData = obj;
  },
  changeNeedcache (state, v) {
    state.needcache = v;
  },
  changeStatus: (state, v) => {
    state.isValid = v;
  },
  changeCurrentRow: (state, v) => {
    state.currentRow = v;
  },
  changeOptionsGrade: (state, v) => {
    state.optionsGrade = v;
  },
  changeGradeValue: (state, v) => {
    state.gradeValue = v;
  }
}
const actions = {
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/roles.js